export default __webpack_public_path__ + "static/media/dobre_kalorije.501332e0.png";